import CoreResize from '../../mixins/core-resize'
import AppPage from '../../mixins/app-page'
import AppImgBg from '../app-img-bg'
import AppFadein from '../app-fadein'
import AppHubItem from '../app-hub-item'
import AppBtn from '../app-btn'


export default
{
    name: 'page-watch-now',

    mixins:
    [
        AppPage,
        CoreResize
    ],

    components:
    {
        AppImgBg,
        AppHubItem,
        AppFadein,
        AppBtn
    },

    data()
    {
        return {
            socialList: [],
            columnLength: 0,
            isMoreBtnEnable: false
        }
    },

    watch:
    {
        contentPage: '_moreCheck'
    },

    created()
    {
        this._videoState = 'stop'

        this._twitchVideoURL = 'https://player.twitch.tv/?channel=' + this.contentGlobal.twitch.channel

        this._moreSocial()
        this._sortSocial()
    },

    destroyed()
    {
        if (this.player)
        {
            const Twitch = window.Twitch

            this.player.removeEventListener(Twitch.Player.PLAY, this._onPlay)
            this.player.removeEventListener(Twitch.Player.PAUSE, this._onPause)
            this.player.removeEventListener(Twitch.Player.ENDED, this._onEnded)
            this._onEnded()
        }
    },

    mounted()
    {
        this.eventHub.$emit('bg-change', '/static/bg/bg-empty.jpg')
        this._initTwitchPlayer()
    },

    methods:
    {
        onResized()
        {
            this._sortSocial()
        },

        openModalRegister()
        {
            this.$root.openModalPlay('watch-now')
        },


        // ------------------------
        //     PLAYER TWITCH

        _initTwitchPlayer()
        {
            const Twitch = window.Twitch

            if (Twitch)
            {
                const options = {
                    width: '100%',
                    height: '100%',
                    playsinline: true,
                    channel: this.contentGlobal.twitch.channel
                }

                const player = new Twitch.Player(this.$el.querySelector('.js-twitch-player'), options)
                player.addEventListener(Twitch.Player.PLAY, this._onPlay)
                player.addEventListener(Twitch.Player.PAUSE, this._onPause)
                player.addEventListener(Twitch.Player.ENDED, this._onEnded)
                this.player = player
            }
            else
            {
                console.error('<page-watch-now> Twitch API not loaded')
            }
        },

        _onPlay()
        {
            if (this._videoState !== 'play')
            {
                this._pushToGTM({
                    event: 'gfinity.video',
                    'gfinity.video.action': 'play',
                    'gfinity.video.resource': this._twitchVideoURL
                })

                this._videoState = 'play'
                this.channelOnline = true
            }
        },

        _onPause()
        {
            if (this._videoState !== 'pause')
            {
                this._pushToGTM({
                    event: 'gfinity.video',
                    'gfinity.video.action': 'pause',
                    'gfinity.video.resource': this._twitchVideoURL
                })

                this._videoState = 'pause'
                this.channelOnline = true
            }
        },

        _onEnded()
        {
            if (this._videoState !== 'ended')
            {
                this._pushToGTM({
                    event: 'gfinity.video',
                    'gfinity.video.action': 'ended',
                    'gfinity.video.resource': this._twitchVideoURL
                })

                this._videoState = 'ended'
                this.channelOnline = false
            }
        },

        _pushToGTM(data)
        {
            if (window.dataLayer)
            {
                window.dataLayer.push(data)
            }
            else
            {
                console.error('Google Tag Manager: dataLayer not defined')
            }
        },


        // ------------------------
        //     SOCIAL WALL

        _moreSocial()
        {
            this.columnLength += 3
            this._moreCheck()
        },

        _moreCheck()
        {
            let isMoreBtnEnable = false
            const columnLength = this.columnLength

            for (const column of this.socialList)
            {
                if (column.length > columnLength)
                {
                    isMoreBtnEnable = true
                }
            }

            this.isMoreBtnEnable = isMoreBtnEnable
        },

        _sortSocial()
        {
            const socialListOriginal = JSON.parse(JSON.stringify(this.contentPage.feed))
            const columnNum = Math.min(Math.max(Math.floor(this.resize.width / 560), 1), 3)
            const socialList = []

            socialList.length = 0

            let i = 0
            while (socialListOriginal.length > 0)
            {
                const social = socialListOriginal.shift()
                const columnId = ((i++) % columnNum)

                social.key = socialListOriginal.length
                if (!socialList[columnId])
                {
                    socialList[columnId] = []
                }

                socialList[columnId].push(social)
            }

            this.socialList = socialList

            this.$nextTick(() => this.$emit('load', this))
            this._moreCheck()
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-watch-now/script.js